import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/layout';
import { Tag, TagLabel, Tooltip } from '@chakra-ui/react';
export default function SharedExperienceUserTempListItem(props) {
  const {
    userTemp,
  } = props;  
  return (
    <>
      {userTemp && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={3}
          backgroundColor="white"
        >
          <Flex alignItems={'center'}>
            <Box
              w="40px"
              h="40px"
              borderRadius="50%"
              backgroundColor="background.grey"
              display="flex"
              alignItems="center"
              justifyContent="center"
              mr={2}
            >
              <Text fontSize="sm" fontWeight="bold" color="text.light.grey">
                {userTemp?.email?.charAt(0).toUpperCase()}
              </Text>
            </Box>
            <Box>
              <Text>{userTemp.email}</Text>
            </Box>
          </Flex>
          <Flex>
            <Tooltip label="This user will be added after signing up">
              <Tag variant="orange">
                  <TagLabel px={2}>Invited</TagLabel>
              </Tag>
            </Tooltip>
          </Flex>
        </Flex>
      )}
    </>
  );
} 